import { createFeatureSelector } from '@ngrx/store';
import { DashboardFeatureCreativeState } from './store.models';
import { StoreKey } from './store.reducer';

export const selectStoreState =
  createFeatureSelector<DashboardFeatureCreativeState>(StoreKey);
